// API Configuration
// يجب تعيين REACT_APP_API_URL في ملف .env
if (!process.env.REACT_APP_API_URL) {
  console.error('⚠️ تحذير: لم يتم تعيين REACT_APP_API_URL في ملف .env');
  console.error('⚠️ يرجى إضافة REACT_APP_API_URL=http://your-server-url/api في ملف .env');
}

export const API_BASE_URL = process.env.REACT_APP_API_URL!;

// Other global configuration can be added here
export const APP_NAME = 'نظام إدارة المخزون';